module.exports = ['$scope', '$state', '$stateParams', '$window', '$filter', '$location', '$anchorScroll', function ($scope, $state, $stateParams, $window, $filter, $location, $anchorScroll) {
    var colors = $stateParams.colors.split(',');
    $location.hash('scrollto');

    var stoneTypes = [];

    angular.forEach(window.MG.stoneTypes, function (stoneType) {
        var active = false;
        var count = 0;

        angular.forEach(stoneType.Colors, function (stoneTypeColor) {
            if (colors.indexOf(stoneTypeColor.Color) !== -1) {
                active = true;
                count += stoneTypeColor.Count;
            }
        });

        stoneType.active = active;
        stoneType.count = count;

        stoneTypes.push(stoneType);
    });

    $scope.stoneTypes = $filter('filter')(stoneTypes, function (stoneType) {
        return stoneType.active;
    });

    $scope.allStoneTypesCount = function () {
        var count = 0;

        angular.forEach($scope.stoneTypes, function (stoneType) {
            count += stoneType.count;
        });

        return count;
    };

    $scope.expandedStoneTypes = [true];

    $scope.btnMoreClick = function ($event, $index) {
        var currentVal = $scope.expandedStoneTypes[$index];
        $event.preventDefault();

        if (typeof (currentVal) === 'undefined'
            || (typeof(currentVal) === 'boolean' && currentVal === false)) {
            $scope.expandedStoneTypes[$index] = true;
        } else {
            $scope.expandedStoneTypes[$index] = false;
        }
    };

    $scope.btnBackClick = function ($event) {
        $event.preventDefault();
        $window.history.back();
        $anchorScroll();
    };

    $scope.getResultsLink = function (key) {
        if (key === 'all') {
            return '/products/#/?category=slabs&colors=' + $stateParams.colors;
        }

        return '/products/#/?category=slabs&subcategory=' + key + '&colors=' + $stateParams.colors;
    };
}];
